import { render } from "./Workspace.vue?vue&type=template&id=36f35f4d&scoped=true"
import script from "./Workspace.vue?vue&type=script&lang=js"
export * from "./Workspace.vue?vue&type=script&lang=js"

import "./Workspace.vue?vue&type=style&index=0&id=36f35f4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f35f4d"]])

export default __exports__